import { CALENDAR_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-event-types';
import type { CalendarEvent, CalendarVisibilityState } from '@/types/calendarTypes';

export function filterEventsByVisibility(
  events: CalendarEvent[],
  visibility: CalendarVisibilityState
): CalendarEvent[] {
  return events.filter((event) => {
    if (event.type === CALENDAR_EVENT_TYPES.BIRTHDAY && !visibility.birthdays) return false;
    if (
      (event.type === CALENDAR_EVENT_TYPES.TASK_DEADLINE || event.type === CALENDAR_EVENT_TYPES.TASK_REMINDER) &&
      !visibility.tasks
    ) {
      return false;
    }
    if (
      (event.type === CALENDAR_EVENT_TYPES.OUTLOOK_VIRTUAL || event.type === CALENDAR_EVENT_TYPES.OUTLOOK_IN_PERSON) &&
      !visibility.events
    ) {
      return false;
    }
    return true;
  });
}
